import { runInspectionFn } from '../utils/runInspectionFn';
import { checkSubscriptionFn } from "../../AccessChecker/checkSubscriptionFn";

export class SubscriptionResult {
    constructor(subscriptionKeys, subscriptionCheckMethod) {
        this.keys = subscriptionKeys || [];
        this.keysCheckMethod = subscriptionCheckMethod || 'AND'; // 'AND' means both keys must be true to be unlocked
    }

    // returns: boolean
    hasSubscriptionTo() {
        return runInspectionFn(checkSubscriptionFn, this.keys, this.keysCheckMethod);
    }
}
